import {NavLink} from "react-router-dom";
import {IconContext} from "react-icons";
import { CiMail } from "react-icons/ci";
import { CiInstagram } from "react-icons/ci";
import { FiLink } from "react-icons/fi";
import { FaArrowCircleLeft } from "react-icons/fa";


export const Contact = () => {
  return (
    <main className="min-h-screen bg-[#0B0B0F] text-white">
      {/* Navigation */}
      <div className="fixed top-5 left-5 z-50">
        <IconContext.Provider value={{ size: "2em", className: "text-white hover:text-gray-400 transition-colors" }}>
          <NavLink to={'/'}>
            <FaArrowCircleLeft />
          </NavLink>
        </IconContext.Provider>
      </div>
      
      {/* Titre de la page en haut */}
      <div className="pt-12 pb-4 text-center">
        <h1 className="text-4xl md:text-5xl font-bold text-white tracking-tight">CON<span className="text-gray-400">TACT</span></h1>
        <div className="w-24 h-1 bg-white mx-auto mt-4 mb-8"></div>
      </div>

      {/* Hero Section */}
      <section className="relative py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl md:text-6xl font-bold text-center mb-6 tracking-tight">
            Contactez-moi
          </h1>
          <p className="text-xl text-gray-300 text-center max-w-2xl mx-auto mb-16">
            Discutons de vos projets photo et donnons vie à vos plus beaux souvenirs
          </p>
        </div>
      </section>

      {/* Contact Cards */}
      <section className="max-w-4xl mx-auto px-4 pb-24">
        <div className="grid md:grid-cols-2 gap-8">
          {/* Email Card */}
          <div className="bg-[#16161e] rounded-lg p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-800">
            <div className="flex flex-col items-center">
              <div className="bg-gray-700 p-4 rounded-full mb-6 border border-gray-600">
                <IconContext.Provider value={{ size: "2.5em", className: "text-white" }}>
                  <CiMail />
                </IconContext.Provider>
              </div>
              <h3 className="text-2xl font-semibold mb-4 text-white">Email</h3>
              <a 
                href="mailto:yohanvision@outlook.com" 
                className="text-gray-300 hover:text-white transition-colors group flex items-center gap-2"
              >
                yohanvision@outlook.com
                <FiLink className="opacity-0 group-hover:opacity-100 transition-opacity" />
              </a>
              <p className="mt-4 text-gray-400 text-center">
                Je réponds généralement dans les 24 heures
              </p>
            </div>
          </div>

          {/* Instagram Card */}
          <div className="bg-[#16161e] rounded-lg p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-800">
            <div className="flex flex-col items-center">
              <div className="bg-gray-700 p-4 rounded-full mb-6 border border-gray-600">
                <IconContext.Provider value={{ size: "2.5em", className: "text-white" }}>
                  <CiInstagram />
                </IconContext.Provider>
              </div>
              <h3 className="text-2xl font-semibold mb-4 text-white">Instagram</h3>
              <a 
                href="https://www.instagram.com/yohan.p0v/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white transition-colors group flex items-center gap-2"
              >
                @yohan.p0v
                <FiLink className="opacity-0 group-hover:opacity-100 transition-opacity" />
              </a>
              <p className="mt-4 text-gray-400 text-center">
                Suivez mon travail et envoyez-moi un message direct
              </p>
            </div>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <p className="text-gray-300">
            Pour toute demande de devis ou information supplémentaire,
            n'hésitez pas à me contacter via l'un de ces moyens.
          </p>
        </div>
      </section>
    </main>
  );
};
